class HeaderSearch {
  constructor() {
    this.headerSearchInput = document.querySelector(
      "input[name='header-search']"
    );
    this.searchInput = document.querySelector("input[name='q']");
    this.headerSearchButton = document.querySelector(".header__search-link a");
    this.closeSearchButton = document.querySelector(
      "#predictive-search-form dialog-close-button button"
    );
    this.predictiveSearchWrapper = document.querySelector(
      ".header-search__form"
    );
    this.clicked = false;
  }

  init() {
    this.headerSearchInput.addEventListener("input", () => {
      this.searchButton();
      this.searchInputValue();
    });
    this.headerSearchInput.addEventListener("keypress", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        this.searchInput.closest("#predictive-search-form").submit();
      }
    });
  }
  searchButton() {
    if (this.headerSearchInput.value.length > 0 && !this.clicked) {
      this.headerSearchButton.click();
      this.clicked = true;
      console.log(this.headerSearchInput.value.length);
    } else if (this.headerSearchInput.value.length <= 0) {
      this.closeSearch();
      this.clicked = false;
      console.log(this.headerSearchInput.value.length);
    }
  }

  searchInputValue() {
    // Only update and dispatch an event if the values are different
    if (this.searchInput.value !== this.headerSearchInput.value) {
      this.searchInput.value = this.headerSearchInput.value;

      // Create a new 'input' event
      const event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });

      // Dispatch the event on searchInput
      this.searchInput.dispatchEvent(event);
    }
  }

  closeSearch() {
    if (this.closeSearchButton && this.headerSearchInput.value.length <= 0) {
      this.closeSearchButton.click();
      this.headerSearchInput.value = "";
    }
  }
}

class CollectionDescription {
  constructor() {
    this.collectionDescriptionReadMore = document.querySelector(
      ".collection-description-read-more"
    );
    // Element varsa initialize et
    if (this.collectionDescriptionReadMore) {
      this.init();
    }
  }

  init() {
    this.collectionDescriptionReadMore.addEventListener("click", () => {
      const description =
        this.collectionDescriptionReadMore.previousElementSibling;
      const isOpen = description.classList.contains("open");

      description.classList.toggle("open");
      this.collectionDescriptionReadMore.textContent = isOpen
        ? "Daha fazla oku"
        : "Daha az göster";
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new HeaderSearch().init();
  new CollectionDescription();
});

// Utility function to preload images, returns a Promise
function preloadImages(imageUrls) {
  const promises = imageUrls.map((url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  });
  return Promise.all(promises);
}

class ProductCardSlider extends HTMLElement {
  constructor() {
    super();
    this.splideContainer = this.querySelector(".splide");
    this.init();
  }

  async init() {
    // Core elements
    this.mediaItems = Array.from(this.querySelectorAll(".product-card__media"));

    // Skip if no slider needed
    if (!this.mediaItems.length || this.mediaItems.length <= 1 || !this.splideContainer) return;


    // Initial setup
    this.splide = new Splide(this.splideContainer, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      drag: false,
      pagination: false,
    })
    this.splide.mount();

    // Preload images using the shared utility
    const imageUrls = this.mediaItems
      .map((item) => {
        const img = item.querySelector("img");
        return img ? img.src : null;
      })
      .filter(Boolean);
    await preloadImages(imageUrls);
  }
}

class ProductColorSwitcher {
  constructor() {
    this.colorSwatches = document.querySelectorAll(".relatedcolors-grid a");
    this.bindEvents();
  }

  bindEvents() {
    this.colorSwatches.forEach((swatch) => {
      swatch.addEventListener(
        "click",
        (event) => {
          const colorSwatch = event.target.closest(
            ".product-card .relatedcolors-item"
          );
          if (colorSwatch) {
            event.preventDefault();
            event.stopPropagation();
            this.updateProductCard(colorSwatch);
          }
        },
        { capture: true }
      );
    });
  }

  updateProductCard(element) {
    const productCard = element.closest(".product-card");
    if (!productCard) return;

    // Preload images before updating the card
    const preloadImages = async (imageUrls) => {
      const promises = imageUrls.map((url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = url;
        });
      });
      return Promise.all(promises);
    };

    // Update product URL
    const links = productCard.querySelectorAll("a[href]");
    links.forEach((link) => {
      link.href = element.dataset.productUrl;
    });

    // Update product title
    const titleElement = productCard.querySelector(
      ".product-title .prodCardTitleText"
    );
    if (titleElement) {
      titleElement.textContent = element.dataset.productTitle;
    }

    // Update product images in slider
    const mediaWrapper = productCard.querySelector(
      ".product-card__media-wrapper"
    );
    if (mediaWrapper) {
      const images = element.dataset.productImages.split(",");

      // Get existing aspect ratio class before clearing content
      const existingImage = mediaWrapper.querySelector("img");
      const aspectClass = existingImage
        ? existingImage.className.match(/aspect-[^\s]+/)?.[0]
        : "aspect-natural";

      // Add loading state
      mediaWrapper.style.opacity = "0.5";
      mediaWrapper.style.transition = "opacity 0.3s ease";

      // Preload images then update DOM
      preloadImages(images).then(() => {
        mediaWrapper.innerHTML = "";

        // Get the reference image element for copying all attributes
        const referenceImg = mediaWrapper
          .closest(".product-card")
          .querySelector(".product-card__media-wrapper img");

        images.forEach((imageUrl, index) => {
          const mediaLink = document.createElement("a");
          mediaLink.href = element.dataset.productUrl;
          mediaLink.className = `product-card__media splide__slide${
            index === 0 ? " active" : ""
          }`;
          mediaLink.setAttribute("data-media-index", index);
          mediaLink.setAttribute("draggable", "false");
          mediaLink.setAttribute("data-instant", "");

          const img = document.createElement("img");
          img.src = imageUrl;

          // Copy all attributes from the reference image if available
          if (referenceImg) {
            // Copy all attributes except src
            Array.from(referenceImg.attributes).forEach((attr) => {
              if (attr.name !== "src") {
                img.setAttribute(attr.name, attr.value);
              }
            });
          }
          // Ensure src is set to the new image
          img.setAttribute("src", imageUrl);

          // Ensure aspect-ratio class is present
          const aspectClass =
            referenceImg && referenceImg.className.match(/aspect-[^\s]+/)?.[0];
          if (aspectClass) {
            img.classList.add(aspectClass);
          } else {
            img.classList.add("aspect-portrait");
          }

          mediaLink.appendChild(img);
          mediaWrapper.appendChild(mediaLink);
        });

        // Remove loading state
        mediaWrapper.style.opacity = "1";

        // Reinitialize ProductCardSlider
        const productCardSlider = productCard.querySelector(
          "product-card-slider"
        );
        if (productCardSlider) {
          productCardSlider.disconnectedCallback?.();
          productCardSlider.init();
        }
      });
    }

    // Update variants popup
    this.updateVariantPopup(productCard, element.dataset.productId);

    // Update all price elements
    const priceList = productCard.querySelector("price-list");
    if (priceList) {
      const regularPrice = element.dataset.productPrice;
      const compareAtPrice = element.dataset.productCompareAtPrice;
      const unitPrice = element.dataset.productUnitPrice;
      const unitPriceMeasurement = element.dataset.productUnitPriceMeasurement
        ? JSON.parse(element.dataset.productUnitPriceMeasurement)
        : null;

      const salePrice = priceList.querySelector("sale-price");
      const compareAtPriceElement = priceList.querySelector("compare-at-price");
      const unitPriceElement = priceList.querySelector("unit-price");

      if (salePrice) {
        const currentClasses = salePrice.className;
        salePrice.innerHTML = `<span class="sr-only">${
          window.themeVariables?.strings?.salePrice || "Sale price"
        }</span>${regularPrice}`;
        salePrice.className = currentClasses;
      }

      if (compareAtPriceElement) {
        const currentClasses = compareAtPriceElement.className;
        if (compareAtPrice) {
          compareAtPriceElement.innerHTML = `<span class="sr-only">${
            window.themeVariables?.strings?.regularPrice || "Regular price"
          }</span>${compareAtPrice}`;
          compareAtPriceElement.style.display = "";
          compareAtPriceElement.className = currentClasses;
        } else {
          compareAtPriceElement.style.display = "none";
        }
      }

      if (unitPriceElement && unitPrice && unitPriceMeasurement) {
        const currentClasses = unitPriceElement.className;
        const referenceValue =
          unitPriceMeasurement.reference_value !== 1
            ? unitPriceMeasurement.reference_value
            : "";
        unitPriceElement.innerHTML = `(${unitPrice}/${referenceValue}${unitPriceMeasurement.reference_unit})`;
        unitPriceElement.style.display = "";
        unitPriceElement.className = currentClasses;
      } else if (unitPriceElement) {
        unitPriceElement.style.display = "none";
      }
    }

    // Update active state
    const otherColors = element.closest(".other-colors");
    otherColors.querySelectorAll(".relatedcolors-item").forEach((item) => {
      item.classList.remove("active");
      item.classList.remove("active-product");
    });
    element.classList.add("active");
    element.classList.add("active-product");
  }

  async updateVariantPopup(productCard, productId) {
    const variantPopup = productCard.querySelector(
      ".product-card__variant-popup"
    );
    if (!variantPopup) return;

    try {
      const response = await fetch(`/products/${productId}.js`);
      const productData = await response.json();

      const variantList = variantPopup.querySelector(
        ".product-card__variant-list"
      );
      if (!variantList) return;

      variantList.innerHTML = "";

      // Find size/beden option
      const sizeOption = productData.options.find((option) => {
        const name = option.name.toLowerCase();
        return name.includes("beden") || name.includes("size");
      });

      if (sizeOption) {
        sizeOption.values.forEach((value) => {
          const variant = productData.variants.find(
            (v) => v.options[sizeOption.position - 1] === value
          );

          if (variant) {
            const button = document.createElement("button");
            button.type = "button";
            button.className = "product-card__variant-button";
            button.dataset.variantId = variant.id;
            button.dataset.optionValue = value;
            button.dataset.inventoryQuantity = variant.inventory_quantity;

            if (!variant.available) {
              button.disabled = true;
              button.innerHTML = `${value}<span class="product-card__variant-sold-out"></span>`;
            } else {
              button.innerHTML = value;

              // Add to cart functionality
              button.onclick = async function (event) {
                event.preventDefault();

                try {
                  const formData = {
                    items: [
                      {
                        id: variant.id,
                        quantity: 1,
                      },
                    ],
                  };

                  const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                  });

                  if (response.ok) {
                    // Close variant popup
                    variantPopup.classList.remove("active");

                    // Get cart drawer
                    const cartDrawer = document.querySelector("cart-drawer");
                    if (cartDrawer) {
                      document.documentElement.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                          bubbles: true,
                        })
                      );
                      cartDrawer.show();
                    }

                    // Dispatch cart update event
                    document.documentElement.dispatchEvent(
                      new CustomEvent("cart:change", {
                        bubbles: true,
                        detail: {
                          baseEvent: "variant:add",
                          cart: await response.json(),
                        },
                      })
                    );
                  }
                } catch (error) {
                  console.error("Error adding to cart:", error);
                }
              };
            }

            variantList.appendChild(button);
          }
        });
      }
    } catch (error) {
      console.error("Error fetching product variants:", error);
    }
  }
}

// Initialize components
function initComponents() {
  if (!window.customElements.get("product-card-slider")) {
    window.customElements.define("product-card-slider", ProductCardSlider);
  }
  new ProductColorSwitcher();
}

// Call initComponents
initComponents();

// Handle dynamic content loading (pagination, AJAX)
document.addEventListener("click", initComponents);
document.addEventListener("DOMContentLoaded", initComponents);
document.addEventListener("shopify:section:load", initComponents);
document.addEventListener("shopify:section:select", initComponents);

// Add variant to cart functionality
HTMLButtonElement.prototype.addToCart = async function (event) {
  event.preventDefault();
  event.stopPropagation();

  const variantId = this.getAttribute("data-variant-id");
  if (!variantId) return;

  // Show loading state
  this.setAttribute("aria-busy", "true");
  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    // Add to cart
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (response.ok) {
      // Close variant popup first
      this.closest(".product-card__variant-popup").classList.remove("active");

      // Get cart data
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartJson = await cartResponse.json();

      // Simple cart refresh
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      // Wait a bit before showing drawer
      await new Promise((resolve) => setTimeout(resolve, 300));

      // Open cart drawer if enabled
      if (window.themeVariables?.settings?.cartType === "drawer") {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.show();
        }
      }
    } else {
      console.error("Error adding to cart:", await response.json());
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    // Remove loading state
    this.removeAttribute("aria-busy");
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
};

class ShopTheLookProductListCarousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const productCards = this.querySelectorAll("product-card");
    productCards.forEach((card) => {
      if (card.hasAttribute("handle")) {
        // Initialize product card functionality
        new ProductCard(card);
      }
    });
  }
}

class ShopTheLookNew {
  constructor() {
    this.shopTheLookBannerImages = document.querySelectorAll(
      ".shop-the-look-new__item-banner img"
    );
    this.shopTheLookOpeners = document.querySelectorAll(
      ".shop-the-look-new__item-banner__shop-button"
    );
    this.shopTheLookClosers = document.querySelectorAll(
      ".shop-the-look-new__item-products-closer"
    );
    this.init();
  }

  init() {
    this.shopTheLookBannerImages.forEach((opener) => {
      opener.addEventListener("click", () => {
        opener
          .closest(".shop-the-look-new__item")
          .querySelector(".shop-the-look-new__item-products-wrapper")
          .classList.toggle("open");
        document.querySelector("html").style.overflow = "hidden";
        document
          .querySelector(".shop-the-look-new__item-products-overlay")
          .classList.toggle("active");
      });
    });
    this.shopTheLookOpeners.forEach((opener) => {
      opener.addEventListener("click", () => {
        opener
          .closest(".shop-the-look-new__item")
          .querySelector(".shop-the-look-new__item-products-wrapper")
          .classList.toggle("open");
        document.querySelector("html").style.overflow = "hidden";
        document
          .querySelector(".shop-the-look-new__item-products-overlay")
          .classList.toggle("active");
      });
    });
    this.shopTheLookClosers.forEach((closer) => {
      closer.addEventListener("click", () => {
        closer
          .closest(".shop-the-look-new__item")
          .querySelector(".shop-the-look-new__item-products-wrapper")
          .classList.remove("open");
        document.querySelector("html").style.overflow = "auto";
        document
          .querySelector(".shop-the-look-new__item-products-overlay")
          .classList.toggle("active");
      });
    });

    document.addEventListener("click", (event) => {
      let openProductsWrapper = document.querySelector(
        ".shop-the-look-new__item-products-wrapper.open"
      );
      if (!openProductsWrapper) return;

      if (
        !event.target.closest(".shop-the-look-new__item-products") &&
        !event.target.closest(".shop-the-look-new__item-banner__shop-button") &&
        !event.target.closest(".shop-the-look-new__item-banner img")
      ) {
        openProductsWrapper.classList.remove("open");
        document.querySelector("html").style.overflow = "auto";
        document
          .querySelector(".shop-the-look-new__item-products-overlay")
          .classList.toggle("active");
      }
    });
  }
}

class BackToTop {
  constructor() {
    this.backToTopButton = document.querySelector("#back-to-top");
    this.init();
  }

  init() {
    if (!this.backToTopButton) return;
    this.backToTopButton.classList.remove("back-to-top--show");
    this.backToTopButton.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    window.addEventListener("scroll", () => {
      if (window.scrollY > 250) {
        this.backToTopButton.classList.add("back-to-top--show");
      } else {
        this.backToTopButton.classList.remove("back-to-top--show");
      }
    });
  }
}

/**
 * Enables horizontal scrolling for a container using mouse click and drag.
 * Usage: new HorizontalDragScroll(document.querySelector('.your-scrollable-class'));
 */
class HorizontalDragScroll {
  /**
   * @param {HTMLElement} container - The scrollable container element.
   */
  constructor(container) {
    if (!container) return;
    this.container = container;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    // Find 4th and 5th parent elements
    this.parent4 = this.getNthParent(this.container, 4);
    this.parent5 = this.getNthParent(this.container, 5);

    // Bind event handlers
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onDocumentMouseMove = this.onDocumentMouseMove.bind(this);
    this.onDocumentMouseUp = this.onDocumentMouseUp.bind(this);
    this.preventParentScroll = this.preventParentScroll.bind(this);
    this.onWheel = this.onWheel.bind(this);

    // Attach event listeners
    this.container.addEventListener("mousedown", this.onMouseDown);
    this.container.addEventListener("mouseleave", this.onMouseLeave);
    this.container.addEventListener("mouseup", this.onMouseUp);
    this.container.addEventListener("mousemove", this.onMouseMove);

    // Add mouse wheel horizontal scroll
    this.container.addEventListener("wheel", this.onWheel, { passive: false });

    // Optional: Prevent image dragging inside the container
    this.container.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
    });
  }

  getNthParent(element, n) {
    let parent = element;
    for (let i = 0; i < n; i++) {
      if (parent.parentElement) {
        parent = parent.parentElement;
      } else {
        return null;
      }
    }
    return parent;
  }

  onMouseDown(e) {
    this.isDown = true;
    this.container.classList.add("is-dragging");
    this.startX = e.pageX - this.container.offsetLeft;
    this.scrollLeft = this.container.scrollLeft;

    // Prevent page scroll and selection
    document.body.classList.add("no-scroll");
    document.addEventListener("mousemove", this.onDocumentMouseMove, {
      passive: false,
    });
    document.addEventListener("mouseup", this.onDocumentMouseUp);
    document.addEventListener("selectstart", this.preventSelection, {
      passive: false,
    });
    document.addEventListener("wheel", this.preventScroll, { passive: false });

    // Prevent scroll/drag on 4th and 5th parents
    [this.parent4, this.parent5].forEach((parent) => {
      if (parent) {
        parent.addEventListener("wheel", this.preventParentScroll, {
          passive: false,
        });
        parent.addEventListener("touchmove", this.preventParentScroll, {
          passive: false,
        });
        parent.addEventListener("scroll", this.preventParentScroll, {
          passive: false,
        });
        // Set overflow hidden
        this._setOverflowHidden(parent);
      }
    });
  }

  onMouseLeave() {
    this.endDrag();
  }

  onMouseUp() {
    this.endDrag();
  }

  onMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.container.offsetLeft;
    const walk = (x - this.startX) * 1.5; // scroll-fastness
    this.container.scrollLeft = this.scrollLeft - walk;
  }

  onDocumentMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    this.onMouseMove(e);
  }

  onDocumentMouseUp() {
    this.endDrag();
  }

  endDrag() {
    if (!this.isDown) return;
    this.isDown = false;
    this.container.classList.remove("is-dragging");
    document.body.classList.remove("no-scroll");
    document.removeEventListener("mousemove", this.onDocumentMouseMove, {
      passive: false,
    });
    document.removeEventListener("mouseup", this.onDocumentMouseUp);
    document.removeEventListener("selectstart", this.preventSelection, {
      passive: false,
    });
    document.removeEventListener("wheel", this.preventScroll, {
      passive: false,
    });

    // Remove scroll/drag prevention and overflow hidden from 4th and 5th parents
    [this.parent4, this.parent5].forEach((parent) => {
      if (parent) {
        parent.removeEventListener("wheel", this.preventParentScroll, {
          passive: false,
        });
        parent.removeEventListener("touchmove", this.preventParentScroll, {
          passive: false,
        });
        parent.removeEventListener("scroll", this.preventParentScroll, {
          passive: false,
        });
        this._restoreOverflow(parent);
      }
    });
  }

  preventSelection(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  preventScroll(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  preventParentScroll(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onWheel(e) {
    // Allow horizontal scroll with mouse wheel, prevent vertical scroll
    if (e.deltaX !== 0 || e.deltaY !== 0) {
      e.preventDefault();
      // Scroll horizontally by both deltaX and deltaY for best UX
      this.container.scrollLeft += e.deltaY !== 0 ? e.deltaY : e.deltaX;
    }
  }

  _setOverflowHidden(element) {
    if (!element) return;
    // Store previous overflow value to restore later
    if (typeof element._prevOverflow === "undefined") {
      element._prevOverflow = element.style.overflow;
    }
    element.style.overflow = "hidden";
  }

  _restoreOverflow(element) {
    if (!element) return;
    if (typeof element._prevOverflow !== "undefined") {
      element.style.overflow = element._prevOverflow;
      delete element._prevOverflow;
    }
  }
}

class FooterAccordion {
  constructor() {
    this.accordionToggles = document.querySelectorAll(
      ".footer-accordion__toggle"
    );
    this.init();
  }

  init() {
    this.accordionToggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        toggle.parentElement.nextElementSibling.classList.toggle("active");
        toggle.classList.toggle("active");
      });
    });
  }
}

class shopthelookimages {
  constructor() {
    this.colorSelectors = document.querySelectorAll(
      ".shop-the-look-new__item-products .OtherColorss"
    );
    this.init();
  }
  init() {
    if (!this.colorSelectors) return;
    this.colorSelectors.forEach((selector) => {
      setTimeout(() => {
        selector.querySelector(".relatedcolors-item.active").click();
      }, 100);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ShopTheLookNew();
  new BackToTop();
  document.querySelectorAll(".horizontal-drag-scroll").forEach((container) => {
    new HorizontalDragScroll(container);
  });
  new FooterAccordion();
  new shopthelookimages();
});


if (!customElements.get("gift-detector")) {
  class GiftDetector extends HTMLElement {
    constructor() {
      super();
      this.giftCheckbox = this.querySelector("input[name='gift-wrap']");
      this.checkoutForm = this.querySelector("form");
      this.giftVariantId = this.getAttribute("data-gift-variant-id");
    }
    connectedCallback() {
      this.checkoutForm.addEventListener("submit", async (event) => {
        if (!this.giftCheckbox || !this.giftVariantId ) return;
        event.preventDefault();
        if (this.giftCheckbox.checked) {
          const cart = await fetch("/cart.js").then((response) => response.json());
          const hasGiftItem = cart.items.some((item)=> item.id == this.giftVariantId);
          if(!hasGiftItem){
            const formData = {
              items: [
                {
                  id: this.giftVariantId,
                  quantity: 1,
                },
              ],
            };
            const response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }).then((data) => data.json());
          }
          window.location.href = "/checkout";
        } else {

          const formData = {
            id: this.giftVariantId,
            quantity: 0
          };
          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }).then((data) => data.json()).then((response)=>{console.log(response)});
          window.location.href = "/checkout";
        }
      });
    }
  }
  customElements.define("gift-detector", GiftDetector);
}